import React from 'react';

export const BookmarkIcon = () => (
  <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_15566_84801)">
      <path
        d="M12.9375 1.96875H5.0625C4.68954 1.96875 4.33185 2.11691 4.06813 2.38063C3.80441 2.64435 3.65625 3.00204 3.65625 3.375V15.75C3.6562 15.9006 3.69648 16.0485 3.7729 16.1784C3.84933 16.3082 3.95911 16.4151 4.09085 16.4882C4.22259 16.5612 4.37149 16.5977 4.52208 16.5937C4.67266 16.5898 4.81945 16.5456 4.94719 16.4658L8.9993 13.9345L13.0528 16.4658C13.1806 16.5456 13.3273 16.5898 13.4779 16.5937C13.6285 16.5977 13.7774 16.5612 13.9091 16.4882C14.0409 16.4151 14.1507 16.3082 14.2271 16.1784C14.3035 16.0485 14.3438 15.9006 14.3438 15.75V3.375C14.3438 3.00204 14.1956 2.64435 13.9319 2.38063C13.6681 2.11691 13.3105 1.96875 12.9375 1.96875ZM12.6562 14.2277L9.44648 12.2217C9.31239 12.1379 9.15743 12.0935 8.9993 12.0935C8.84116 12.0935 8.68621 12.1379 8.55211 12.2217L5.34375 14.2277V3.65625H12.6562V14.2277Z"
        fill="#1B4DFF"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_15566_84801"
        x="-2"
        y="-1"
        width="22"
        height="22"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.054902 0 0 0 0 0.0588235 0 0 0 0 0.0666667 0 0 0 0.06 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_15566_84801" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_15566_84801" result="shape" />
      </filter>
    </defs>
  </svg>
);

export const BookmarkIconFilled = () => (
  <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_15566_3170)">
      <path
        d="M12.9375 2.25H5.0625C4.76413 2.25 4.47798 2.36853 4.267 2.5795C4.05603 2.79048 3.9375 3.07663 3.9375 3.375V15.75C3.93755 15.8504 3.96446 15.9489 4.01545 16.0354C4.06643 16.1219 4.13963 16.1931 4.22744 16.2418C4.31525 16.2904 4.41448 16.3147 4.51483 16.312C4.61519 16.3094 4.713 16.2799 4.79812 16.2267L9 13.6005L13.2026 16.2267C13.2877 16.2797 13.3854 16.309 13.4857 16.3116C13.5859 16.3142 13.685 16.2899 13.7727 16.2412C13.8604 16.1926 13.9335 16.1214 13.9845 16.0351C14.0354 15.9487 14.0624 15.8503 14.0625 15.75V3.375C14.0625 3.07663 13.944 2.79048 13.733 2.5795C13.522 2.36853 13.2359 2.25 12.9375 2.25Z"
        fill="#1B4DFF"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_15566_3170"
        x="-2"
        y="-1"
        width="22"
        height="22"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.054902 0 0 0 0 0.0588235 0 0 0 0 0.0666667 0 0 0 0.06 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_15566_3170" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_15566_3170" result="shape" />
      </filter>
    </defs>
  </svg>
);
